import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class Constants {
  public REVENUE = 'REVENUE';
  public BUSINESS = 'Business';

  // Shop Type
  public ShopTypeMiles = 'MILES';
  public ShopTypeMoney = 'MONEY';
  public ShopTypeCashAndMiles = 'Cash_Plus_Miles';

  // Price Type
  public PriceType_Revenue = 'Revenue';
  public PriceType_Award = 'Award';

  // Search/Page Type
  public FLEX_AIRPORT = 'FLEX_AIRPORT';
  public CALENDAR_SEARCH = 'CALENDAR_SEARCH';
  public FLEX_DAYS = 'FLEX_DAYS';
  public FLEX_WEEKS = 'FLEX_WEEKS';
  public FLEX_DATE = 'FLEX_DATE';

  // Trip Type
  public TripType_MULTICITY = 'MULTICITY';
  public TripType_ROUND_TRIP = 'ROUND_TRIP';
  public TripType_ONE_WAY = 'ONE_WAY';

  constructor() {}
}
